import React from 'react';
import './sidebar-footer.scss';

type SidebarFooterProps = {
    children: React.ReactNode;
};

export const SidebarFooter = ({ children }: SidebarFooterProps) => {
    return (
        <div className='sidebar-footer'>
            {children}
        </div>
    );
};
